export const ArticleHeader = ({ headline, leadText = null, theme }) => (
  <header className="root">
    <h1 className="headline">{headline}</h1>
    {leadText && <p className="leadText">{leadText}</p>}
    <style jsx>{`
      .root {
        margin-right: ${theme.mobileGutter / 2}px;
        margin-left: ${theme.mobileGutter / 2}px;
        margin-top: 2.5rem;
        margin-bottom: 1.5rem;
        color: var(--bgBlueish__text);
      }

      .headline {
        margin: 0;
        font-size: 32px;
        line-height: 1.05;
      }

      .leadText {
        margin: 0.75rem 0 0 0;
        font-size: 22px;
        line-height: 1.4;
      }

      @media screen and (min-width: 750px) {
        .root {
          margin-right: 0;
          margin-left: ${theme.leftMargin + theme.gutterWidth}%;
          width: ${theme.contentWidth}%;
        }

        .headline {
          font-size: 42px;
        }
      }
    `}</style>
  </header>
);
